import { apiClient } from './api';
import { Payment, Invoice, PaginatedResponse } from '../types';

interface BackendPaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  pages: number;
}

class PaymentService {
  // Admin APIs
  async getPaymentHistory(filters?: {
    status?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<Payment>> {
    const response = await apiClient.get<BackendPaginatedResponse<Payment>>('/admin/payments', filters);
    return {
      items: response.data,
      total: response.total,
      page: response.page,
      limit: filters?.limit || 10,
      totalPages: response.pages
    };
  }

  async getInvoiceById(id: string): Promise<Invoice> {
    return apiClient.get<Invoice>(`/admin/invoices/${id}`);
  }

  // Member APIs
  async getMemberPayments(): Promise<Payment[]> {
    return apiClient.get<Payment[]>('/member/payments');
  }

  async initiatePayment(amount: number, type: string): Promise<{
    orderId: string;
    razorpayOrderId: string;
    amount: number;
    currency: string;
  }> {
    return apiClient.post('/member/payments/initiate', { amount, type });
  }

  async verifyPayment(data: {
    razorpayOrderId: string;
    razorpayPaymentId: string;
    razorpaySignature: string;
    amount: number;
    type: string;
  }): Promise<{ payment: Payment; invoice: Invoice }> {
    return apiClient.post('/member/payments/verify', data);
  }
}

export const paymentService = new PaymentService();
